import axios from "axios";

const BASE_URL = "https://backsanpancracio.us-3.evennode.com";

// ✅ GET: Traer todos los destinos
export const getDestinos = async () => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/destinos`;

  try {
    const resp = await axios.get(url, {
      headers: { token },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al obtener destinos",
    };
  }
};

// ✅ GET: Traer una destino por ID
export const getDestinoById = async (id) => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/destinos/${id}`;

  try {
    const resp = await axios.get(url, {
      headers: { token },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al obtener destino",
    };
  }
};

// ✅ POST: Crear nuevo destino
export const postDestino = async (destinoData) => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/destinos`;

  try {
    const resp = await axios.post(url, destinoData, {
      headers: {
        "Content-Type": "application/json",
        token,
      },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al crear destino",
    };
  }
};

// ✅ PUT: Actualizar destino
export const putDestino = async (id, destinoData) => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/destinos/${id}`;

  try {
    const resp = await axios.put(url, destinoData, {
      headers: {
        "Content-Type": "application/json",
        token,
      },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al actualizar destino",
    };
  }
};

// ✅ DELETE: Desactivar destino
export const deleteDestino = async (id) => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/destinos/${id}`;

  try {
    const resp = await axios.delete(url, {
      headers: { token },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al eliminar destino",
    };
  }
};
